import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/invoices', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/invoices', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/invoices/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = (id, data) => {
  return httpClient
    .put(`/api/invoices/delete/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const studentSubscript = data => {
  return httpClient
    .post('/api/service-subscriptions/queries', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getFeeSetupWithDetail = data => {
  return httpClient
    .post('/api/fee-item-details/queries', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const printPDF = (id, Options = {}) => {
  return httpClient
    .get(`/api/invoices/generate-pdf/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const feeGroupDetail = data => {
  return httpClient
    .post('/api/fee-group-item-details/queries', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const checkStudentRegisterVehicel = studentId => {
  return httpClient
    .get(`/api/student-register-vehicles/${studentId}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const latestInvoiceStudent = studentId => {
  return httpClient
    .get(`/api/invoices/${studentId}/latest`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const eligable = data => {
  return httpClient
    .post('/api/invoices-eligables-payments', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const createNewStudent = data => {
  return httpClient
    .post('/api/invoices-create-students', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const bankStudent = studentId => {
  return httpClient
    .get(`/api/invoices/bank-students/${studentId}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getClassId = data => {
  return httpClient
    .post('/api/invoices-get-class-id', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const checkIsDuplicateFeeType = data => {
  return httpClient
    .post('/api/invoices-check-is-duplicate-fee-types', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const exchangeRate = data => {
  return httpClient
    .get('/api/invoices/exchange-rates', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getStudent = (Options = {}) => {
  return httpClient
    .get('/api/invoices/invoice-view-models', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const invoiceFormViewModel = (Options = {}) => {
  return httpClient
    .get('/api/invoices/invoice-view-models', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  store,
  find,
  destroy,
  studentSubscript,
  getFeeSetupWithDetail,
  printPDF,
  feeGroupDetail,
  checkStudentRegisterVehicel,
  latestInvoiceStudent,
  eligable,
  createNewStudent,
  bankStudent,
  getClassId,
  checkIsDuplicateFeeType,
  exchangeRate,
  getStudent,
  invoiceFormViewModel
}
